import { render, staticRenderFns } from "./CommonTalkback.vue?vue&type=template&id=97dcb2fe&scoped=true"
import script from "./CommonTalkback.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonTalkback.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CommonTalkback.vue?vue&type=style&index=0&id=97dcb2fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dcb2fe",
  null
  
)

export default component.exports